import { isLoggedIn } from "@/helpers/storage/AuthHelper";

export default (to, from, next) =>  {
  if (isLoggedIn()) {
    next({ name: "dashboard" });
    return false;
  } 
}
